import { EnumResult, useGetEnums } from 'api-hooks/common';
import { Option } from 'baseui/select';
import CustomFormControl from 'components/elements/custom-form-control';
import Select from 'components/elements/master/select-input';
import useGenerateSelectProps from 'hooks/use-generate-select-props';
import * as React from 'react';

function transformer(item: EnumResult): Option {
  return {
    id: item.value,
    label: item.label,
  };
}
export interface SaleTypeSelectInputProps {
  label?: string;
  placeholder?: string;
  onClose?: () => void;
  value?: string;
  onSelected?: (value?: string) => void;
  noMargin?: boolean;
}

export default function SaleTypeSelectInput(props: SaleTypeSelectInputProps) {
  const { label, placeholder, value, onSelected } = props;

  const query = useGetEnums({
    class: 'sale-transaction-type',
  });

  const { options, value: _value } = useGenerateSelectProps({
    query,
    transformer,
    value,
  });

  return (
    <CustomFormControl label={label} noMargin={props.noMargin}>
      <Select
        type="select"
        placeholder={placeholder}
        options={options}
        value={_value}
        onChange={(params: any) => {
          onSelected?.(params?.option?.id);
        }}
      />
    </CustomFormControl>
  );
}
